/* global alertBarCookieName */
( d => {
	const alertCloseButtons = d.querySelectorAll( '.alert-bar__close, .alert-bar__alt-close' );

	alertCloseButtons.forEach( alertCloseButton => {
		alertCloseButton.addEventListener( 'click', event => {
			event.preventDefault();
			const hrefAttr = alertCloseButton.getAttribute( 'href' );
			const alertBar = alertCloseButton.closest( '.alert-bar' );

			if ( alertBar ) {
				alertBar.style.display = 'none';
				setAlertBarCookie();
			}

			if ( '#' !== hrefAttr && '' !== hrefAttr ) {
				const sanitizedHref = encodeURIComponent( hrefAttr );
				window.location.href = sanitizedHref;
			}
		} );
	} );

	function setAlertBarCookie() {
		if ( typeof alertBarCookieName !== 'undefined' ) {
			const days = 5;
			const date = new Date();
			date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
			document.cookie = alertBarCookieName + '=1; expires=' + date.toUTCString();
		}
	}
} )( document );
